<template>
  <div id="page-user-list">
    <vx-card>
      <vs-table :data="venues">
        <template slot="thead">
          <vs-th>Venue Name</vs-th>
          <vs-th>Address</vs-th>
          <vs-th>Last 24hrs</vs-th>
          <vs-th>Last 7 days</vs-th>
          <vs-th>Last 31 days</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.name">{{ tr.name }}</vs-td>
            <vs-td :data="tr.street">{{ tr.street }}</vs-td>
            <vs-td :data="tr.today_bookings_count">{{
              tr.today_bookings_count
            }}</vs-td>
            <vs-td :data="tr.week_bookings_count">{{
              tr.week_bookings_count
            }}</vs-td>
            <vs-td :data="tr.month_bookings_count">{{
              tr.month_bookings_count
            }}</vs-td>
            <template class="expand-user" slot="expand">
              <div class="con-expand-users w-full">
                <div class="con-btns-user flex items-center justify-between">
                  <div class="con-userx flex items-center justify-start">
                    <b>Portals List</b>
                  </div>
                </div>
                <div class="w-full mt-2">
                  <vs-table
                    pagination
                    :max-items="itemsPerPage"
                    :data="tr.portals"
                  >
                    <template slot="thead">
                      <vs-th>Type</vs-th>
                      <vs-th>Role</vs-th>
                      <vs-th>Username</vs-th>
                      <vs-th>Password</vs-th>
                      <vs-th>DeviceID</vs-th>
                      <vs-th>Last 24hrs</vs-th>
                      <vs-th>Last 7 days</vs-th>
                      <vs-th>Last 31 days</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr
                        :data="ptr"
                        :key="indexptr"
                        v-for="(ptr, indexptr) in data"
                      >
                        <vs-td :data="ptr.type">{{
                          ptr.type ? ptr.type : "---"
                        }}</vs-td>
                        <vs-td :data="ptr.role">{{
                          ptr.role ? ptr.role : "---"
                        }}</vs-td>
                        <vs-td>{{
                          ptr.user && ptr.type != "device"
                            ? ptr.user.email
                            : "---"
                        }}</vs-td>
                        <vs-td>{{
                          ptr.user && ptr.type != "device"
                            ? ptr.user.api_password
                            : "---"
                        }}</vs-td>
                        <vs-td :data="ptr.device_id">{{ ptr.device_id }}</vs-td>
                        <vs-td :data="ptr.booking_count.daily">
                          {{ ptr.booking_count.daily }}
                        </vs-td>
                        <vs-td :data="ptr.booking_count.weekly">
                          {{ ptr.booking_count.weekly }}
                        </vs-td>
                        <vs-td :data="ptr.booking_count.monthly">
                          {{ ptr.booking_count.monthly }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </template>
          </vs-tr>
        </template>
      </vs-table>
      <div class="my-5">
        <vs-pagination
          v-if="total_items"
          :total="total_pages"
          v-model="currentx"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>
<script>
import { _statistics } from "@/services/Company";
export default {
  data() {
    return {
      venues: [],
      items_per_page: 1,
      total_items: 0,
      total_pages: 1,
      currentx: 1,
      companyID: this.$store.state.company.companyID,
    };
  },
  watch: {
    "$store.state.company.companyID"(val) {
      this.companyID = val;
      this.getVenues();
    },
    currentx(val) {
      this.getVenues(val);
    },
  },
  mounted() {
    this.getVenues();
  },
  methods: {
    getVenues(page = 1) {
      this.$vs.loading();
      _statistics(this.companyID, page)
        .then(
          (response) => {
            this.$vs.loading.close();
            this.venues = response.data.obj.list.data;
            this.total_items = response.data.obj.list.total;
            this.items_per_page = response.data.obj.list.per_page;
            this.total_pages = response.data.obj.list.last_page;
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
  },
};
</script>
